import { NavigationStructure } from '../../../data/types';
import { MainMenuItem } from './MainMenuItem';
import { MenuToggle } from './MenuToggle/MenuToggle';
import * as s from './Navigation.scss';
import { SignIn } from './SignIn';
import { Languages } from './Languages';
import { HFConfig } from '../../../config';

export interface MainMenuProps {
  navigation: NavigationStructure;
  t(key: string): string;
  config: HFConfig;
}

export const MainMenu = ({ navigation, t, config }: MainMenuProps) => {
  const { language } = config;
  return `
    ${MenuToggle({ t })}
    <div class="${s.overlay}"></div>
    <nav class="${s.menuWrapper}" aria-label="${t('nav_aria_label')}" data-hook="wix-header-main-menu">
      <div class="${s.menuContainer}">
        <div class="${s.menuBackground}"></div>
        <ul
          class="${s.menu}"
          ${language === 'en' ? 'role="menu"' : ''}
        >
          ${navigation.map((item) => MainMenuItem({ item, t, language })).join('')}
          ${Languages({ language })}
          ${SignIn({ config, t })}
        </ul>
      </div>
    </nav>
  `;
};
